import DivIconValue from "./DivIconValue";

const TableMQConfigAlerts = ({item, _TC}) => {
    return (
        <>
            <div>
                <DivIconValue item={item} field="nivel_llenado_a" _TC={_TC} />
                <DivIconValue item={item} field="nivel_llenado_d" _TC={_TC} />
                <DivIconValue item={item} field="difllen" _TC={_TC} />
                <DivIconValue item={item} field="difvac" _TC={_TC} />
                <DivIconValue item={item} field="sacc" _TC={_TC} />
                <DivIconValue item={item} field="t_volcado" _TC={_TC} />
                <DivIconValue item={item} field="t_mov_permanente" _TC={_TC} />
            </div>
            <div className="mt-2">
                <DivIconValue item={item} field="angulo_a" _TC={_TC} />
                <DivIconValue item={item} field="angulo_d" _TC={_TC} />
                <DivIconValue item={item} field="alta_temp_a" _TC={_TC} />
                <DivIconValue item={item} field="alta_temp_d" _TC={_TC} />
                <DivIconValue item={item} field="baja_temp_a" _TC={_TC} />
                <DivIconValue item={item} field="baja_temp_d" _TC={_TC} />
                <DivIconValue item={item} field="incendio" _TC={_TC} />
            </div>
        </>
    );
};

export default TableMQConfigAlerts;
